import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FDConfirmationDialog, FDStack } from '@facet-wealth/design';
import WizardSpecificPageLinkBottom
  from 'Components/ComponentLibrary/Components/Uncategorized/WizardSpecificPageLinkBottom';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useMountedGuard from 'Hooks/useMountedGuard';
import Content from '../Content';

const QuickEditClosingCosts = ({ collection }) => {
  const { refreshModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();
  const { doWithMountedGuard } = useMountedGuard();
  const [open, _setOpen] = useState(false);
  const [loading, _setLoading] = React.useState(false);
  const setOpen = doWithMountedGuard(_setOpen);
  const setLoading = doWithMountedGuard(_setLoading);

  if (collection.resources().length() === 0) {
    return null;
  }

  const resource = collection.resources().head();
  const specificPageLink = resource.relationship(fr.relationships.specificPageLink.name)?.link('related');

  const handleConfirm = async (e) => {
    e.stopPropagation();
    setLoading(true);

    try {
      await specificPageLink.Post();
      await refreshModalCollection();
    } catch (err) {
      displayErrorMessage(err);
    }

    setLoading(false);
    setOpen(false);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setOpen(false);
  };

  return (
    <FDStack direction="column" alignItems="center" justifyContent="flex-start">
      <Content resource={resource} />
      <WizardSpecificPageLinkBottom
        resource={resource}
        onClick={() => setOpen(true)}
      />
      <FDConfirmationDialog
        title="Are you sure?"
        message="Resetting upfront costs will remove all additional upfront expenses and restore any removed standard expenses. Any unsaved changes made to any fields in the edit screen will also be lost."
        open={open}
        onConfirm={(e) => handleConfirm(e)}
        onClose={(e) => handleClose(e)}
        loading={loading}
      />
    </FDStack>
  );
};

QuickEditClosingCosts.defaultProps = {};

QuickEditClosingCosts.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default QuickEditClosingCosts;
